<template>
  <div class="content evl-page">
    <!-- 0. TOP MAIN TABS -->
    <div class="evl-main-tabs-card row-data">
      <el-tabs
        v-model="mainTab"
        type="card"
        class="sk-tabs evl-main-tabs"
      >
        <el-tab-pane name="EVALUATION">
          <template slot="label">
            <span class="evl-main-tab-item">
              <i class="el-icon-edit-outline" /> Nhận xét
            </span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="CATEGORY_TEMPLATES">
          <template slot="label">
            <span class="evl-main-tab-item">
              <i class="el-icon-collection" /> Mẫu nhận xét
            </span>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- TAB 1: NHẬN XÉT -->
    <div v-show="mainTab === 'EVALUATION'">
      <!-- 1. TOOLBAR CARD -->
      <div class="evl-toolbar-card row-data">
        <div class="evl-toolbar-section evl-toolbar-section--filter">
          <div style="margin-bottom: 12px;">
            <p class="evl-card-title">Nhận xét học sinh</p>
            <p class="evl-card-subtitle">Quản lý nhận xét theo ngày, tuần, tháng cho từng lớp</p>
          </div>
          <el-form
              ref="searchFormRef"
              :model="searchRequest"
              label-position="top"
              class="evl-form-grid"
          >
            <el-form-item v-if="!isPeriodicTab" :label="dateFilterLabel" class="evl-form-item">
              <!-- Ngày -->
              <el-date-picker
                  v-if="activeTab === 'DAILY'"
                  v-model="searchRequest.date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="dd/MM/yyyy"
                  placeholder="Chọn ngày"
                  :clearable="false"
                  style="width: 180px"
                  @change="fetchData"
              />
              <!-- Tuần -->
              <el-date-picker
                  v-else-if="activeTab === 'WEEKLY'"
                  v-model="searchRequest.date"
                  type="week"
                  value-format="yyyy-MM-dd"
                  format="Tuần WW (từ dd/MM/yyyy)"
                  placeholder="Chọn tuần"
                  :clearable="false"
                  style="width: 240px"
                  @change="fetchData"
              />
              <!-- Tháng -->
              <el-date-picker
                  v-else-if="activeTab === 'MONTHLY'"
                  v-model="searchRequest.date"
                  type="month"
                  value-format="yyyy-MM"
                  format="MM/yyyy"
                  placeholder="Chọn tháng"
                  :clearable="false"
                  style="width: 160px"
                  @change="fetchData"
              />
            </el-form-item>

            <el-form-item label="Khối" class="evl-form-item">
              <el-select
                  v-model="searchRequest.gradeId"
                  placeholder="Chọn khối"
                  style="width: 160px"
                  @change="handleGradeChange"
              >
                <el-option
                    v-for="item in gradeOfSchoolList"
                    :key="item.id"
                    :label="item.gradeName"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="Lớp" class="evl-form-item">
              <el-select
                  v-model="searchRequest.classId"
                  placeholder="Chọn lớp"
                  style="width: 180px"
                  @change="handleClassChange"
              >
                <el-option
                    v-for="item in filteredClassList"
                    :key="item.id"
                    :label="item.className"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item v-if="isPeriodicTab" label="Năm" class="evl-form-item">
              <el-date-picker
                  v-model="periodicYear"
                  type="year"
                  value-format="yyyy"
                  format="yyyy"
                  placeholder="Chọn năm"
                  :clearable="false"
                  style="width: 120px"
                  @change="handlePeriodicYearChange"
              />
            </el-form-item>
          </el-form>
        </div>

        <div class="evl-toolbar-divider"/>

        <div class="evl-toolbar-section evl-toolbar-section--action">
          <div style="margin-bottom: 12px;">
            <p class="evl-card-title">Tác vụ</p>
            <p class="evl-card-subtitle">{{ actionSubtitle }}</p>
          </div>
          <div class="evl-action-group flex items-center">
            <template v-if="!isPeriodicTab && selectedStudents.length > 0 && getAppTypeUserLogin === 'plus'">
              <span class="evl-selected-count">Đã chọn {{ selectedStudents.length }}</span>
              <el-button
                class="evl-action-button"
                type="success"
                plain
                icon="el-icon-check"
                @click="handleBatchApproval(true)"
              >
                Duyệt đã chọn
              </el-button>
              <el-button
                class="evl-action-button"
                type="warning"
                plain
                icon="el-icon-close"
                @click="handleBatchApproval(false)"
              >
                Huỷ duyệt
              </el-button>
            </template>
            <el-button
              class="evl-action-button"
              type="primary"
              :icon="addBatchIcon"
              @click="handleAddBatchByCurrentTab"
            >
              {{ addBatchButtonText }}
            </el-button>
            <el-button
              class="evl-action-button"
              type="success"
              plain
              icon="el-icon-download"
              @click="handleOpenExportDialog"
            >
              Xuất Excel
            </el-button>
            <el-dropdown class="evl-task-dropdown" trigger="click" @command="handleAction">
              <el-button class="evl-action-button" type="primary" plain>
                Tác vụ <i class="el-icon-arrow-down el-icon--right"/>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="evaluationConfig" icon="el-icon-setting">
                    Thiết lập
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>

      <!-- 2. TABLE CARD -->
      <div class="evl-table-card row-data">
        <div class="evl-card-head evl-table-head">
          <div>
            <p class="evl-card-title">Danh sách nhận xét</p>
            <p class="evl-card-subtitle">{{ tableSubtitle }}</p>
          </div>
        </div>

        <div>
          <el-tabs
              v-model="activeTab"
              type="card"
              class="sk-tabs"
              @tab-click="handleTabChange"
          >
            <el-tab-pane name="DAILY">
              <template slot="label">
                <i class="el-icon-date"/> Ngày
              </template>
            </el-tab-pane>
            <el-tab-pane name="WEEKLY">
              <template slot="label">
                <i class="el-icon-document"/> Tuần
              </template>
            </el-tab-pane>
            <el-tab-pane name="MONTHLY">
              <template slot="label">
                <i class="el-icon-notebook-2"/> Tháng
              </template>
            </el-tab-pane>
            <el-tab-pane name="PERIODIC">
              <template slot="label">
                <i class="el-icon-s-claim"/> Định kỳ
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="evl-table-wrapper">
          <!-- Normal evaluation table (DAILY/WEEKLY/MONTHLY) -->
          <EvaluationTable
              v-if="!isPeriodicTab"
              ref="evaluationTable"
              :data="tableData"
              :loading="tableLoading"
              :active-tab="activeTab"
              @view="handleViewDetail"
              @edit="handleEdit"
              @delete="handleDelete"
              @approve="handleApprove"
              @add-for-student="handleAddForStudent"
              @activity-log="handleActivityLog"
              @view-files="handleViewFiles"
              @selection-change="handleStudentSelectionChange"
          />

          <!-- Periodic evaluation table -->
          <div v-if="isPeriodicTab">
            <div v-if="periodicSelection.length > 0" class="evl-periodic-toolbar">
              <div class="evl-periodic-batch-actions">
                <span class="evl-periodic-selected">Đã chọn {{ periodicSelection.length }} học sinh</span>
                <el-button size="mini" type="success" plain icon="el-icon-check" @click="handlePeriodicBatchApprove">
                  Duyệt đã chọn
                </el-button>
                <el-button size="mini" type="warning" plain icon="el-icon-close" @click="handlePeriodicBatchUnapprove">
                  Huỷ duyệt
                </el-button>
                <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="handlePeriodicBatchDelete">
                  Xoá đã chọn
                </el-button>
              </div>
            </div>
            <PeriodicEvaluationTable
                ref="periodicTable"
                :data="periodicData"
                :loading="periodicLoading"
                @view="handlePeriodicView"
                @history="handlePeriodicHistory"
                @add="handlePeriodicAdd"
                @edit="handlePeriodicEdit"
                @delete="handlePeriodicDelete"
                @approve="handlePeriodicApprove"
                @view-files="handleViewFiles"
                @selection-change="handlePeriodicSelectionChange"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- TAB 2: MẪU NHẬN XÉT (DANH MỤC & MẪU) -->
    <div v-if="mainTab === 'CATEGORY_TEMPLATES'">
      <EvaluationCategorySettingsPage :is-embedded="true" />
    </div>

    <!-- 3. DIALOGS -->
    <EvaluationDailyFormDialog
        ref="dailyDialog"
        :class-id="searchRequest.classId"
        :date="searchRequest.date"
        :student-list="studentListFromTable"
        @saved="fetchData"
    />

    <EvaluationDailyBatchFormDialog
        ref="dailyBatchDialog"
        :date="searchRequest.date"
        @saved="handleDailyBatchSaved"
    />

    <EvaluationPeriodBatchFormDialog
        ref="weeklyBatchDialog"
        period="WEEKLY"
        :date="searchRequest.date"
        @saved="handlePeriodBatchSaved"
    />

    <EvaluationPeriodBatchFormDialog
        ref="monthlyBatchDialog"
        period="MONTHLY"
        :date="searchRequest.date"
        @saved="handlePeriodBatchSaved"
    />

    <EvaluationWeeklyFormDialog
        ref="weeklyDialog"
        :class-id="searchRequest.classId"
        :date="searchRequest.date"
        :student-list="studentListFromTable"
        @saved="fetchData"
    />

    <EvaluationMonthlyFormDialog
        ref="monthlyDialog"
        :class-id="searchRequest.classId"
        :date="searchRequest.date"
        :student-list="studentListFromTable"
        @saved="fetchData"
    />

    <EvaluationDetailDialog
        ref="detailDialog"
        :class-id="searchRequest.classId"
        :date="searchRequest.date"
        @updated="fetchData"
    />

    <EvaluationActivityLogDialog
        ref="activityLogDialog"
        :class-id="searchRequest.classId"
        :periodic="isPeriodicTab"
        :year="periodicYear"
    />

    <EvaluationFilePreviewDialog ref="filePreviewDialog"/>

    <EvaluationConfigDialog
        ref="evaluationConfigDialog"
        :dialog-visible="evaluationConfigDialogVisible"
        @dialog-close="evaluationConfigDialogVisible = false"
    />

    <!-- EXPORT DIALOG -->
    <EvaluationExportDialog
        ref="exportDialog"
        :class-info="currentClassInfo"
        :class-id="searchRequest.classId"
    />

    <!-- PERIODIC DIALOGS -->
    <PeriodicEvaluationDetailDialog
        ref="periodicDetailDialog"
        :year="periodicYear"
        @edit="handlePeriodicEditFromDetail"
        @delete="handlePeriodicDeleteFromDetail"
        @approve="handlePeriodicApproveFromDetail"
        @add-period="handlePeriodicAddPeriodFromDetail"
        @updated="handlePeriodicDetailUpdated"
    />

    <PeriodicEvaluationFormDialog
        ref="periodicFormDialog"
        :class-id="searchRequest.classId"
        :class-name="currentClassName"
        :grade-id="searchRequest.gradeId"
        :year="periodicYear"
        @saved="handlePeriodicSaved"
    />
  </div>
</template>

<script>
import {mapState} from "vuex";
import moment from "moment";
import EvaluationService from "@/modules/evaluation/services/EvaluationService";
import PeriodicEvaluationService from "@/modules/evaluation/services/PeriodicEvaluationService";
import EvaluationTable from "@/modules/evaluation/components/EvaluationTable.vue";
import PeriodicEvaluationTable from "@/modules/evaluation/components/PeriodicEvaluationTable.vue";
import EvaluationDailyFormDialog from "@/modules/evaluation/components/dialog/EvaluationDailyFormDialog.vue";
import EvaluationDailyBatchFormDialog from "@/modules/evaluation/components/dialog/EvaluationDailyBatchFormDialog.vue";
import EvaluationPeriodBatchFormDialog
  from "@/modules/evaluation/components/dialog/EvaluationPeriodBatchFormDialog.vue";
import EvaluationWeeklyFormDialog from "@/modules/evaluation/components/dialog/EvaluationWeeklyFormDialog.vue";
import EvaluationMonthlyFormDialog from "@/modules/evaluation/components/dialog/EvaluationMonthlyFormDialog.vue";
import EvaluationDetailDialog from "@/modules/evaluation/components/dialog/EvaluationDetailDialog.vue";
import EvaluationActivityLogDialog from "@/modules/evaluation/components/dialog/EvaluationActivityLogDialog.vue";
import EvaluationFilePreviewDialog from "@/modules/evaluation/components/dialog/EvaluationFilePreviewDialog.vue";
import EvaluationConfigDialog from "@/modules/evaluation/components/dialog/EvaluationConfigDialog.vue";
import PeriodicEvaluationDetailDialog from "@/modules/evaluation/components/dialog/PeriodicEvaluationDetailDialog.vue";
import PeriodicEvaluationFormDialog from "@/modules/evaluation/components/dialog/PeriodicEvaluationFormDialog.vue";
import EvaluationCategorySettingsPage from "@/modules/evaluation/EvaluationCategorySettingsPage.vue";
import EvaluationExportDialog from "@/modules/evaluation/components/dialog/EvaluationExportDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "EvaluationPage",
  components: {
    EvaluationTable,
    PeriodicEvaluationTable,
    EvaluationDailyFormDialog,
    EvaluationDailyBatchFormDialog,
    EvaluationPeriodBatchFormDialog,
    EvaluationWeeklyFormDialog,
    EvaluationMonthlyFormDialog,
    EvaluationDetailDialog,
    EvaluationActivityLogDialog,
    EvaluationFilePreviewDialog,
    EvaluationConfigDialog,
    PeriodicEvaluationDetailDialog,
    PeriodicEvaluationFormDialog,
    EvaluationCategorySettingsPage,
    EvaluationExportDialog,
  },
  data() {
    return {
      mainTab: "EVALUATION",
      searchRequest: {
        gradeId: "",
        classId: "",
        date: moment().format("YYYY-MM-DD"),
      },
      activeTab: "DAILY",
      tableData: [],
      tableLoading: false,
      approvalLoading: false,
      evaluationConfigDialogVisible: false,
      // ─── Periodic ─────────────────────────────────
      periodicYear: String(moment().year()),
      periodicData: [],
      periodicLoading: false,
      periodicSelection: [],
      selectedStudents: [],
    };
  },
  computed: {
    ...mapState("classStore", ["classListCommon"]),
    ...mapState("classStore", ["classInTeacher"]),
    ...mapState("gradeModule", ["gradeOfSchoolList"]),
    classList() {
      const appType = this.getAppTypeUserLogin;
      if (appType === "teacher") {
        return this.classInTeacher || [];
      }
      return this.classListCommon || [];
    },
    filteredClassList() {
      if (!this.searchRequest.gradeId) {
        return this.classList;
      }
      return this.classList.filter(c => c.idGrade === this.searchRequest.gradeId);
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    schoolId() {
      return this.$store.state.auth.user.schoolId;
    },
    teacherId() {
      return this.$store.state.auth.user.id;
    },
    teacherName() {
      return this.$store.state.auth.user.fullName;
    },
    tableSubtitle() {
      const tabLabel = {DAILY: "ngày", WEEKLY: "tuần", MONTHLY: "tháng", PERIODIC: "định kỳ"};
      return `Hiển thị nhận xét ${tabLabel[this.activeTab]} của lớp`;
    },
    dateFilterLabel() {
      const labels = {DAILY: "Ngày", WEEKLY: "Tuần", MONTHLY: "Tháng", PERIODIC: "Năm"};
      return labels[this.activeTab] || "Ngày";
    },
    studentListFromTable() {
      // Derive student list from the by-class API response
      return this.tableData.map(item => ({
        studentId: item.studentId,
        studentName: item.studentName,
      }));
    },
    // ─── Periodic computed ────────────────────────────
    isPeriodicTab() {
      return this.activeTab === "PERIODIC";
    },
    periodicStudentList() {
      // Only STUDYING students for create form
      return this.periodicData
          .filter(s => s.kidStatus === "STUDYING")
          .map(s => ({studentId: s.studentId, studentName: s.studentName}));
    },
    periodicNextPeriodNumber() {
      if (!this.periodicData || this.periodicData.length === 0) return 1;
      let maxPeriod = 0;
      this.periodicData.forEach(s => {
        if (s.evaluations) {
          s.evaluations.forEach(ev => {
            if (ev.periodNumber > maxPeriod) maxPeriod = ev.periodNumber;
          });
        }
      });
      return maxPeriod + 1;
    },
    currentClassName() {
      const cls = this.filteredClassList.find(c => c.id === this.searchRequest.classId);
      return cls ? cls.className : "";
    },
    currentClassInfo() {
      return {
        className: this.currentClassName,
        schoolName: this.$store.state.auth.user?.school?.schoolName || "OneKids School",
        teacherName: this.teacherName,
      };
    },
    actionSubtitle() {
      switch (this.activeTab) {
        case "DAILY":
          return "Nhận xét ngày";
        case "WEEKLY":
          return "Nhận xét tuần";
        case "MONTHLY":
          return "Nhận xét tháng";
        case "PERIODIC":
          return "Nhận xét định kỳ";
        default:
          return "Thêm nhận xét mới";
      }
    },
    addBatchButtonText() {
      switch (this.activeTab) {
        case "DAILY":
          return "Nhận xét ngày cả lớp";
        case "WEEKLY":
          return "Nhận xét tuần cả lớp";
        case "MONTHLY":
          return "Nhận xét tháng cả lớp";
        case "PERIODIC":
          return "Nhận xét cả lớp";
        default:
          return "Nhận xét cả lớp";
      }
    },
    addBatchIcon() {
      switch (this.activeTab) {
        case "DAILY":
          return "el-icon-date";
        case "WEEKLY":
          return "el-icon-document";
        case "MONTHLY":
          return "el-icon-notebook-2";
        case "PERIODIC":
          return "el-icon-plus";
        default:
          return "el-icon-plus";
      }
    },
  },
  async created() {
    if (this.$route.query.tab === "templates" || this.$route.query.tab === "category") {
      this.mainTab = "CATEGORY_TEMPLATES";
    }
    const appType = this.getAppTypeUserLogin;
    if (appType === "plus") {
      await this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList");
      await this.$store.dispatch("classStore/fetchDataClassListCommon");
    }
    if (appType === "teacher") {
      await this.$store.dispatch("classStore/fetchDataClassInTeacher");
    }
    await this.$nextTick();
    // Auto-select first grade
    if (this.gradeOfSchoolList && this.gradeOfSchoolList.length > 0) {
      this.searchRequest.gradeId = this.gradeOfSchoolList[0].id;
    }
    // Auto-select first class in filtered list
    if (this.filteredClassList.length > 0) {
      this.searchRequest.classId = this.filteredClassList[0].id;
    }
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.searchRequest.classId || !this.searchRequest.date) return;
      this.tableLoading = true;
      try {
        const requestDate = this.activeTab === "MONTHLY"
            ? moment(this.searchRequest.date, "YYYY-MM", true).startOf("month").format("YYYY-MM-DD")
            : this.searchRequest.date;
        const params = {
          schoolId: this.schoolId,
          classId: this.searchRequest.classId,
          date: requestDate,
          type: this.activeTab,
        };
        const res = await EvaluationService.getByClass(params);
        this.tableData = Array.isArray(res.data.data) ? res.data.data : [];
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Không thể tải dữ liệu nhận xét!"
        );
        this.tableData = [];
      } finally {
        this.tableLoading = false;
      }
    },

    handleClassChange() {
      if (this.isPeriodicTab) {
        this.fetchPeriodicData();
      } else {
        this.fetchData();
      }
    },

    handleGradeChange() {
      // Reset class, auto-select first class of the selected grade, then fetch
      this.searchRequest.classId = "";
      this.$nextTick(() => {
        if (this.filteredClassList.length > 0) {
          this.searchRequest.classId = this.filteredClassList[0].id;
        }
        if (this.isPeriodicTab) {
          this.fetchPeriodicData();
        } else {
          this.fetchData();
        }
      });
    },

    handleTabChange() {
      this.selectedStudents = [];
      this.$refs.evaluationTable?.clearSelection();
      // Reset date value phù hợp khi chuyển tab
      if (this.activeTab === "DAILY") {
        this.searchRequest.date = moment().format("YYYY-MM-DD");
        this.fetchData();
      } else if (this.activeTab === "WEEKLY") {
        // el-date-picker type="week" cần ngày đầu tuần
        this.searchRequest.date = moment().startOf("isoWeek").format("YYYY-MM-DD");
        this.fetchData();
      } else if (this.activeTab === "MONTHLY") {
        this.searchRequest.date = moment().format("YYYY-MM");
        this.fetchData();
      } else if (this.activeTab === "PERIODIC") {
        this.fetchPeriodicData();
      }
    },

    handleAddBatchByCurrentTab() {
      if (!this.searchRequest.classId) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn lớp trước!");
        return;
      }
      if (this.isPeriodicTab) {
        this.handlePeriodicAddBatch();
        return;
      }

      if (!this.studentListFromTable || this.studentListFromTable.length === 0) {
        NotifyMessage.leftCornerNotificationError("Lớp hiện tại chưa có học sinh nào!");
        return;
      }

      switch (this.activeTab) {
        case "DAILY":
          this.$refs.dailyBatchDialog.openForCreate(this.selectedStudents, this.studentListFromTable);
          break;
        case "WEEKLY":
          this.$refs.weeklyBatchDialog.openForCreate(this.selectedStudents, this.studentListFromTable);
          break;
        case "MONTHLY":
          this.$refs.monthlyBatchDialog.openForCreate(this.selectedStudents, this.studentListFromTable);
          break;
      }
    },

    handleAddEvaluation(command) {
      if (!this.searchRequest.classId) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn lớp trước!");
        return;
      }
      switch (command) {
        case "dailyBatch":
          this.$refs.dailyBatchDialog.openForCreate(this.selectedStudents, this.studentListFromTable);
          break;
        case "weeklyBatch":
          this.$refs.weeklyBatchDialog.openForCreate(this.selectedStudents, this.studentListFromTable);
          break;
        case "monthlyBatch":
          this.$refs.monthlyBatchDialog.openForCreate(this.selectedStudents, this.studentListFromTable);
          break;
      }
    },

    handleAction(command) {
      if (command === "evaluationConfig") {
        this.evaluationConfigDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.evaluationConfigDialog.getDataInitial();
        });
      }
    },

    handleOpenExportDialog() {
      if (!this.searchRequest.classId) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn lớp trước khi xuất Excel!");
        return;
      }

      const isPeriodic = this.isPeriodicTab;
      const allStudents = isPeriodic
        ? this.periodicData.map(s => ({ studentId: s.studentId, studentName: s.studentName }))
        : this.studentListFromTable;

      const preSelectedIds = isPeriodic
        ? this.periodicSelection.map(s => s.studentId)
        : this.selectedStudents.map(s => s.studentId);

      this.$refs.exportDialog.open({
        type: this.activeTab,
        mode: "STUDENT_SHEETS",
        currentDate: isPeriodic ? this.periodicYear : this.searchRequest.date,
        allStudents,
        preSelectedIds,
        tableData: this.tableData,
        periodicData: this.periodicData,
      });
    },

    goToCategorySettings() {
      this.mainTab = "CATEGORY_TEMPLATES";
    },

    handleAddForStudent(student) {
      if (!this.searchRequest.classId) return;
      switch (this.activeTab) {
        case "DAILY":
          this.$refs.dailyDialog.openForCreate(student);
          break;
        case "WEEKLY":
          this.$refs.weeklyDialog.openForCreate(student);
          break;
        case "MONTHLY":
          this.$refs.monthlyDialog.openForCreate(student);
          break;
      }
    },

    handleStudentSelectionChange(selection) {
      this.selectedStudents = selection;
    },

    handleDailyBatchSaved() {
      this.selectedStudents = [];
      this.$refs.evaluationTable?.clearSelection();
      this.fetchData();
    },

    handlePeriodBatchSaved() {
      this.handleDailyBatchSaved();
    },

    handleViewDetail(row) {
      this.$refs.detailDialog.open(row, this.activeTab);
    },

    handleActivityLog({studentId, studentName}) {
      this.$refs.activityLogDialog.open({
        studentId,
        studentName,
        date: this.searchRequest.date,
        evaluationType: this.activeTab,
      });
    },

    handleViewFiles(files) {
      this.$refs.filePreviewDialog.open(files);
    },

    handleEdit(row) {
      switch (this.activeTab) {
        case "DAILY":
          this.$refs.dailyDialog.openForEdit(row);
          break;
        case "WEEKLY":
          this.$refs.weeklyDialog.openForEdit(row);
          break;
        case "MONTHLY":
          this.$refs.monthlyDialog.openForEdit(row);
          break;
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm(
            "Bạn có chắc chắn muốn xóa nhận xét này? Thao tác không thể hoàn tác.",
            "Xác nhận xóa",
            {confirmButtonText: "Xóa", cancelButtonText: "Hủy", type: "warning"}
        );
      } catch {
        return;
      }

      try {
        const params = {
          schoolId: this.schoolId,
          classId: this.searchRequest.classId,
          studentId: row.studentId,
          date: this.searchRequest.date,
          uid: row.evaluation.uid,
        };
        let res;

        if (row.evaluation.type === "DAILY") {
          res = await EvaluationService.deleteDaily(params);
        } else if (row.evaluation.type === "WEEKLY") {
          res = await EvaluationService.deleteWeekly(params);
        } else {
          res = await EvaluationService.deleteMonthly(params);
        }

        NotifyMessage.leftCornerNotificationSuccess(res.data.message || "Xóa thành công!");
        this.fetchData();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Xóa thất bại!"
        );
      }
    },

    async handleApprove({studentId, evaluation}) {
      if (!evaluation || !evaluation.uid || !studentId || this.approvalLoading) return;

      try {
        await this.$confirm(
            "Bạn có chắc chắn muốn duyệt nhận xét này?",
            "Xác nhận duyệt",
            {confirmButtonText: "Duyệt", cancelButtonText: "Hủy", type: "warning"}
        );
      } catch {
        return;
      }

      this.approvalLoading = true;
      try {
        const res = await EvaluationService.approve({
          classId: this.searchRequest.classId,
          studentId,
          date: evaluation.date || evaluation.evaluationDate || this.searchRequest.date,
          evaluationUid: evaluation.uid,
          evaluationType: evaluation.type || evaluation.evaluationType || this.activeTab,
        });
        NotifyMessage.leftCornerNotificationSuccess(
            res.data.message || "Duyệt nhận xét thành công!"
        );
        await this.fetchData();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Duyệt nhận xét thất bại!"
        );
      } finally {
        this.approvalLoading = false;
      }
    },

    async handleBatchApproval(approved) {
      const targets = this.selectedStudents
          .map(row => {
            const evaluation = row.evaluations && row.evaluations[0];
            if (!evaluation || !evaluation.uid) return null;
            const isApproved = evaluation.approved !== false;
            return isApproved === approved
                ? null
                : {studentId: row.studentId, uid: evaluation.uid};
          })
          .filter(Boolean);
      if (targets.length === 0) {
        NotifyMessage.leftCornerNotificationError(
            approved ? "Không có nhận xét chờ duyệt trong lựa chọn!" : "Không có nhận xét đã duyệt trong lựa chọn!"
        );
        return;
      }

      const actionLabel = approved ? "Duyệt" : "Huỷ duyệt";
      try {
        await this.$confirm(`${actionLabel} nhận xét của ${targets.length} học sinh đã chọn?`,
            `Xác nhận ${actionLabel.toLowerCase()}`, {
              confirmButtonText: actionLabel,
              cancelButtonText: "Huỷ",
              type: "warning",
            });
      } catch {
        return;
      }

      this.approvalLoading = true;
      try {
        await EvaluationService.approveBatch({
          classId: this.searchRequest.classId,
          evaluationType: this.activeTab,
          date: this.searchRequest.date,
          approved,
          students: targets,
        });
        NotifyMessage.leftCornerNotificationSuccess(`${actionLabel} nhận xét thành công!`);
        this.selectedStudents = [];
        this.$refs.evaluationTable?.clearSelection();
        await this.fetchData();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || `${actionLabel} nhận xét thất bại!`
        );
      } finally {
        this.approvalLoading = false;
      }
    },

    // ═══════════════════════════════════════════════════
    // ─── PERIODIC METHODS ─────────────────────────────
    // ═══════════════════════════════════════════════════

    async fetchPeriodicData() {
      if (!this.searchRequest.classId) return;
      this.periodicLoading = true;
      try {
        const params = {
          classId: this.searchRequest.classId,
          year: this.periodicYear,
        };
        const res = await PeriodicEvaluationService.getByClass(params);
        this.periodicData = Array.isArray(res.data.data) ? res.data.data : [];
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Không thể tải dữ liệu nhận xét định kỳ!"
        );
        this.periodicData = [];
      } finally {
        this.periodicLoading = false;
      }
    },

    handlePeriodicYearChange() {
      this.fetchPeriodicData();
    },

    handlePeriodicSelectionChange(selection) {
      this.periodicSelection = selection || [];
    },

    async handlePeriodicBatchApprove() {
      await this.handlePeriodicBatchApproval(true);
    },

    async handlePeriodicBatchUnapprove() {
      await this.handlePeriodicBatchApproval(false);
    },

    async handlePeriodicBatchApproval(approved) {
      const students = this.periodicSelection
          .map(row => {
            const evaluation = this._getLatestEvaluation(row);
            const isApproved = evaluation ? evaluation.approved !== false : false;
            return evaluation && isApproved !== approved
                ? {studentId: row.studentId, uid: evaluation.uid}
                : null;
          })
          .filter(Boolean);
      if (students.length === 0) {
        NotifyMessage.leftCornerNotificationError(
            approved ? "Không có nhận xét chờ duyệt trong lựa chọn!" : "Không có nhận xét đã duyệt trong lựa chọn!"
        );
        return;
      }
      const actionLabel = approved ? "Duyệt" : "Huỷ duyệt";
      try {
        await this.$confirm(`${actionLabel} nhận xét gần nhất của ${students.length} học sinh đã chọn?`,
            `Xác nhận ${actionLabel.toLowerCase()}`, {
          confirmButtonText: actionLabel,
          cancelButtonText: "Huỷ",
          type: "warning",
        });
      } catch {
        return;
      }
      try {
        await PeriodicEvaluationService.approve({
          year: Number(this.periodicYear),
          approved,
          students,
        });
        NotifyMessage.leftCornerNotificationSuccess(`${actionLabel} nhận xét thành công!`);
        await this.fetchPeriodicData();
        this.periodicSelection = [];
        this.$refs.periodicTable?.clearSelection();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || `${actionLabel} thất bại!`);
      }
    },

    async handlePeriodicBatchDelete() {
      const students = this.periodicSelection
          .map(row => {
            const evaluation = this._getLatestEvaluation(row);
            return evaluation ? {studentId: row.studentId, uid: evaluation.uid} : null;
          })
          .filter(Boolean);
      if (students.length === 0) return;
      try {
        await this.$confirm(`Xoá nhận xét gần nhất của ${students.length} học sinh đã chọn?`, "Xác nhận xoá", {
          confirmButtonText: "Xoá",
          cancelButtonText: "Huỷ",
          type: "warning",
        });
      } catch {
        return;
      }
      try {
        await PeriodicEvaluationService.delete({
          year: Number(this.periodicYear),
          students,
        });
        NotifyMessage.leftCornerNotificationSuccess("Xoá nhận xét thành công!");
        await this.fetchPeriodicData();
        this.periodicSelection = [];
        this.$refs.periodicTable?.clearSelection();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Xoá thất bại!");
      }
    },

    handlePeriodicView(row) {
      this.$refs.periodicDetailDialog.open(row);
    },

    handlePeriodicHistory(row) {
      this.$refs.activityLogDialog.open({
        studentId: row.studentId,
        studentName: row.studentName,
        evaluationType: "PERIODIC",
        date: `${this.periodicYear}-01-01`,
      });
    },

    handlePeriodicAdd(row) {
      // Open form for single student
      this.$refs.periodicFormDialog.openForCreate(
          [{studentId: row.studentId, studentName: row.studentName}],
          this._getNextPeriodicPeriodNumber(row),
          row
      );
    },

    handlePeriodicAddBatch() {
      if (!this.searchRequest.classId) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn lớp trước!");
        return;
      }
      this.$refs.periodicFormDialog.openForCreate(
          this.periodicStudentList,
          this.periodicNextPeriodNumber
      );
    },

    handlePeriodicEdit(row) {
      // Edit the latest evaluation
      const latest = this._getLatestEvaluation(row);
      if (!latest) return;
      this.$refs.periodicFormDialog.openForEdit(
          {studentId: row.studentId, studentName: row.studentName},
          latest
      );
    },

    handlePeriodicEditFromDetail({studentData, evaluation}) {
      this.$refs.periodicFormDialog.openForEdit(
          {studentId: studentData.studentId, studentName: studentData.studentName},
          evaluation
      );
    },

    async handlePeriodicDelete(row) {
      const latest = this._getLatestEvaluation(row);
      if (!latest) return;
      await this._doPeriodicDelete(row, latest);
    },

    async handlePeriodicDeleteFromDetail({studentData, evaluation}) {
      await this._doPeriodicDelete(studentData, evaluation);
    },

    async _doPeriodicDelete(studentData, evaluation) {
      try {
        await this.$confirm(
            `Xoá nhận xét lần ${evaluation.periodNumber} của ${studentData.studentName}?`,
            "Xác nhận xoá",
            {confirmButtonText: "Xoá", cancelButtonText: "Huỷ", type: "warning"}
        );
      } catch {
        return;
      }

      try {
        await PeriodicEvaluationService.delete({
          year: Number(this.periodicYear),
          students: [{studentId: studentData.studentId, uid: evaluation.uid}],
        });
        NotifyMessage.leftCornerNotificationSuccess("Xoá nhận xét thành công!");
        await this.fetchPeriodicData();
        this._refreshPeriodicDetailDialog(studentData.studentId);
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Xoá thất bại!"
        );
      }
    },

    async handlePeriodicApprove(row) {
      const latest = this._getLatestEvaluation(row);
      if (!latest) return;
      await this._doPeriodicApprove(row, latest);
    },

    async handlePeriodicApproveFromDetail({studentData, evaluation}) {
      await this._doPeriodicApprove(studentData, evaluation);
    },

    async _doPeriodicApprove(studentData, evaluation) {
      try {
        await this.$confirm(
            `Duyệt nhận xét lần ${evaluation.periodNumber} của ${studentData.studentName}?`,
            "Xác nhận duyệt",
            {confirmButtonText: "Duyệt", cancelButtonText: "Huỷ", type: "warning"}
        );
      } catch {
        return;
      }

      try {
        await PeriodicEvaluationService.approve({
          year: Number(this.periodicYear),
          students: [{studentId: studentData.studentId, uid: evaluation.uid}],
        });
        NotifyMessage.leftCornerNotificationSuccess("Duyệt nhận xét thành công!");
        await this.fetchPeriodicData();
        this._refreshPeriodicDetailDialog(studentData.studentId);
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Duyệt thất bại!"
        );
      }
    },

    async handlePeriodicSaved() {
      await this.fetchPeriodicData();
    },

    async handlePeriodicDetailUpdated() {
      await this.fetchPeriodicData();
      // Refresh detail dialog with new data
      if (this.$refs.periodicDetailDialog && this.$refs.periodicDetailDialog.studentData) {
        const sid = this.$refs.periodicDetailDialog.studentData.studentId;
        this._refreshPeriodicDetailDialog(sid);
      }
    },

    handlePeriodicAddPeriodFromDetail(studentData) {
      this.$refs.periodicFormDialog.openForCreate(
          [{studentId: studentData.studentId, studentName: studentData.studentName}],
          this._getNextPeriodicPeriodNumber(studentData),
          studentData
      );
    },

    _getNextPeriodicPeriodNumber(student) {
      const evaluations = Array.isArray(student?.evaluations) ? student.evaluations : [];
      const maxPeriod = evaluations.reduce((max, evaluation) => {
        const periodNumber = Number(evaluation?.periodNumber) || 0;
        return Math.max(max, periodNumber);
      }, 0);
      return maxPeriod + 1;
    },

    _getLatestEvaluation(row) {
      if (!row.evaluations || row.evaluations.length === 0) return null;
      return row.evaluations.reduce((latest, ev) =>
              ev.periodNumber > (latest.periodNumber || 0) ? ev : latest
          , row.evaluations[0]);
    },

    _refreshPeriodicDetailDialog(studentId) {
      if (this.$refs.periodicDetailDialog && this.$refs.periodicDetailDialog.visible) {
        const updated = this.periodicData.find(s => s.studentId === studentId);
        if (updated) {
          this.$refs.periodicDetailDialog.refresh(updated);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-table";

/* ─── evl-page ─────────────────────────────────── */
.evl-page {
  padding: 4px 0 16px;

  .row-data {
    margin-bottom: 20px;
  }
}

/* ─── Toolbar card ─────────────────────────────── */
.evl-toolbar-card {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.evl-toolbar-section {
  min-width: 0;
}

.evl-toolbar-section--filter {
  flex: 2;
}

.evl-toolbar-section--action {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.evl-toolbar-divider {
  width: 1px;
  align-self: stretch;
  background: #e2e8f0;
  flex-shrink: 0;
  margin: 0 4px;
}

/* ─── Table card ───────────────────────────────── */
.evl-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 18px 18px 14px;
}

/* ─── Card head ────────────────────────────────── */
.evl-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.evl-table-head {
  align-items: center;
}

.evl-card-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.evl-card-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #64748b;
}

/* ─── Action button ────────────────────────────── */
.evl-action-group > * + * {
  margin-left: 12px;
}

.evl-action-button {
  min-width: 130px;
  font-weight: 600;
  border-radius: 10px;
}

/* ─── Table wrapper ────────────────────────────── */
.evl-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

/* ─── Form grid (filter) ──────────────────────── */
.evl-form-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.evl-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/deep/ .evl-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 600;
  line-height: 1.5;
}

/* ─── Override inputs ──────────────────────────── */
/deep/ .evl-page .el-input__inner,
/deep/ .evl-page .el-select .el-input__inner {
  border-radius: 10px;
}

/deep/ .evl-page .el-button {
  border-radius: 10px;
}

/* ─── Disabled & Readonly form controls (màu xanh nổi bật dễ đọc) ─── */
/deep/ .el-input.is-disabled .el-input__inner,
/deep/ .el-input.is-disabled input,
/deep/ input:disabled,
/deep/ input[disabled],
/deep/ .el-textarea.is-disabled .el-textarea__inner,
/deep/ .el-textarea.is-disabled textarea,
/deep/ textarea:disabled,
/deep/ textarea[disabled],
/deep/ .el-select .el-input.is-disabled .el-input__inner,
/deep/ .el-date-editor.is-disabled,
/deep/ .el-date-editor.is-disabled .el-input__inner,
/deep/ .el-date-editor.is-disabled input,
/deep/ .el-date-editor.is-disabled .el-range-input,
/deep/ .el-input-number.is-disabled .el-input__inner,
/deep/ input[readonly],
/deep/ textarea[readonly],
/deep/ .el-input.is-readonly .el-input__inner {
  color: #1d4ed8 !important;
  -webkit-text-fill-color: #1d4ed8 !important;
  font-weight: 600 !important;
  background-color: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

/deep/ .el-input.is-disabled .el-input__prefix,
/deep/ .el-input.is-disabled .el-input__suffix,
/deep/ .el-input.is-disabled .el-input__icon {
  color: #1d4ed8 !important;
}

/deep/ .el-radio.is-disabled .el-radio__label,
/deep/ .el-radio__input.is-disabled + .el-radio__label,
/deep/ .el-radio__input.is-disabled.is-checked + .el-radio__label,
/deep/ .el-checkbox.is-disabled .el-checkbox__label,
/deep/ .el-checkbox__input.is-disabled + .el-checkbox__label,
/deep/ .el-checkbox__input.is-disabled.is-checked + .el-checkbox__label {
  color: #1d4ed8 !important;
  -webkit-text-fill-color: #1d4ed8 !important;
  font-weight: 600 !important;
}

/* ─── Table header override ────────────────────── */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}

/deep/ .sk-table thead tr {
  height: 56px;
}

/deep/ .sk-table tbody td {
  background: #ffffff;
}

/* ─── Tabs ─────────────────────────────────────── */
/deep/ .sk-tabs .el-tabs__nav {
  background: transparent;
  border: none;
}

/deep/ .sk-tabs .el-tabs__nav-wrap::after {
  background: #2563eb;
  height: 2px;
}

/deep/ .sk-tabs .el-tabs__item {
  background: #e5e7eb;
  color: #4b5563;
  font-weight: 600;
  border: 1px solid #d1d5db !important;
  border-bottom: none !important;
  border-radius: 8px 8px 0 0;
  transition: background 0.15s, color 0.15s;

  i {
    margin-right: 6px;
  }
}

/deep/ .sk-tabs .el-tabs__item:hover:not(.is-active) {
  background: #d1d5db;
  color: #1e293b;
}

/deep/ .sk-tabs .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2563eb !important;
  border-color: #2563eb !important;
}

/deep/ .sk-tabs .el-tabs__nav-scroll {
  float: right;
}

/deep/ .sk-tabs .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none;
}

/deep/ .sk-tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #2563eb;
}

/deep/ .sk-tabs.el-tabs--card > .el-tabs__header {
  border-bottom: none;
  margin-bottom: 0;
}

/deep/ .sk-tabs .el-tabs__item:hover:not(.is-active) {
  background: #d1d5db;
  color: #1e293b;
}

/deep/ .sk-tabs .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2563eb !important;
  border-color: #2563eb !important;
}

/deep/ .sk-tabs .el-tabs__nav-scroll {
  float: right;
}

/deep/ .sk-tabs .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none;
}

/deep/ .sk-tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #2563eb;
}

/deep/ .sk-tabs.el-tabs--card > .el-tabs__header {
  border-bottom: none;
  margin-bottom: 0;
}

/* ─── Periodic toolbar ─────────────────────────── */
.evl-periodic-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 0;
}

.evl-periodic-batch-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.evl-periodic-selected {
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

/* ─── Top Main Navigation Tabs ─────────────────── */
.evl-main-tabs-card {
  padding: 10px 14px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
  margin-bottom: 16px;

  /deep/ .el-tabs__nav-scroll {
    float: left !important;
  }

  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
    border-bottom: none !important;
  }

  /deep/ .el-tabs__nav {
    border: none !important;
  }

  /deep/ .el-tabs__item {
    border: 1px solid #e2e8f0 !important;
    border-radius: 10px !important;
    margin-right: 8px;
    height: 40px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 600;
    color: #475569 !important;
    background: #f8fafc !important;
    padding: 0 20px !important;
    transition: all 0.2s ease;

    i {
      margin-right: 6px;
      font-size: 15px;
    }

    &:hover {
      color: #2563eb !important;
      background: #eff6ff !important;
      border-color: #bfdbfe !important;
    }

    &.is-active {
      color: #ffffff !important;
      background: #2563eb !important;
      border-color: #2563eb !important;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
    }
  }
}

.evl-main-tab-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
</style>
